import Link from "next/link";
import type { ButtonProps } from "./button.interface";

export function Button({
  children,
  variant = "primary",
  className,
  href,
  target,
  rel,
  onClick,
  type = "button",
  disabled,
}: ButtonProps) {
  const classes = ["button", `button-${variant}`, className]
    .filter(Boolean)
    .join(" ");

  if (href !== undefined) {
    return (
      <Link href={href} target={target} rel={rel} className={classes}>
        <span className="h-[22px] text-trim-both">
        {children}
        </span>
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
       <span className="h-[22px] text-trim-both">
        {children}
        </span>
    </button>
  );
}
